import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './header.styles.scss';

class Header extends React.Component{

  constructor(props){
    super(props);
    this.state = {};
  }

  goTo = (event,url) => {
    event.preventDefault();
    return this.props.history.push('/'+url);    
  }

  componentDidMount(){
    console.log(this.props.currentPage);
  }  

  render(){
    return(
      <React.Fragment>
        <div className="sectionHeaderContentWrapper">
          
          {
            this.props.currentPage !== "baslangic" ?
            this.props.currentPage !== "success" &&
              <React.Fragment>
              <h2 className="sectionHeaderTitle">{this.props.language.keywords.katilimciBilgiFormu}</h2>          
              <nav className="sectionNavbar">
                <div>
                  <Link to={`${this.props.language.routes.signup}/step-1`} className={`nav-links ${this.props.currentPage === "step-1" ? 'nav-active' : ''}`}>
                    {this.props.language.keywords.birinciAdim}
                  </Link>              
                </div>
                <div>
                  <Link to={`${this.props.language.routes.signup}/step-2`} className={`nav-links ${this.props.currentPage === "step-2" ? 'nav-active' : ''}`}>
                    {this.props.language.keywords.ikinciAdim}
                  </Link> 
                </div>
                <div>
                  <Link to={`${this.props.language.routes.signup}/step-3`} className={`nav-links ${this.props.currentPage === "step-3" ? 'nav-active' : ''}`}>
                    {this.props.language.keywords.ucuncuAdim}
                  </Link> 
                </div>
                <div className={this.props.currentPage === 'step-4' ? 'nav-active' : ''}>
                  <Link to={`${this.props.language.routes.signup}/step-4`} className={`nav-links ${this.props.currentPage === "step-4" ? 'nav-active' : ''}`}>
                    {this.props.language.keywords.dorduncuAdim}
                  </Link> 
                </div>
                <div className={this.props.currentPage === 'step-5' ? 'nav-active' : ''}>
                  <Link to={`${this.props.language.routes.signup}/step-5`} className={`nav-links ${this.props.currentPage === "step-5" ? 'nav-active' : ''}`}>
                    {this.props.language.keywords.besinciAdim}
                  </Link>
                </div>
              </nav>
              </React.Fragment>
              : <h2 className="webSectionTitle">{this.props.language.keywords.merhaba}!</h2>
          } 
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.project.language
  }
}

export default connect(mapStateToProps)(withRouter(Header));